import { render, staticRenderFns } from "./EduSubject.vue?vue&type=template&id=a17e1a8e&scoped=true&"
import script from "./EduSubject.vue?vue&type=script&lang=js&"
export * from "./EduSubject.vue?vue&type=script&lang=js&"
import style0 from "./EduSubject.vue?vue&type=style&index=0&id=a17e1a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17e1a8e",
  null
  
)

export default component.exports